import { createFileRoute } from '@tanstack/react-router';
import { LocationsPage } from '@/features/inventory/LocationsPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/locations')({
  component: LocationsPage,
});
